<template>
  <div class="min-h-screen bg-surface flex items-center justify-center px-4">
    <div class="text-center max-w-md">
      <!-- Icon -->
      <div class="w-20 h-20 mx-auto mb-6 rounded-2xl flex items-center justify-center" :style="iconStyle">
        <span class="material-symbols-rounded text-white" style="font-size: 40px;">{{ icon }}</span>
      </div>

      <!-- Error code -->
      <p class="text-display-small font-bold text-on-surface mb-2">{{ statusCode }}</p>

      <!-- Title -->
      <h1 class="text-title-large font-semibold text-on-surface mb-3">{{ title }}</h1>

      <!-- Description -->
      <p class="text-body-medium text-on-surface-variant mb-8">{{ description }}</p>

      <!-- Actions -->
      <div class="flex flex-col sm:flex-row gap-3 justify-center">
        <button
          @click="handleClearError"
          class="md3-btn-filled inline-flex items-center justify-center gap-2"
        >
          <span class="material-symbols-rounded" style="font-size: 18px;">home</span>
          Volver al inicio
        </button>
        <button
          v-if="statusCode !== 404"
          @click="retry"
          class="md3-btn-outlined inline-flex items-center justify-center gap-2"
        >
          <span class="material-symbols-rounded" style="font-size: 18px;">refresh</span>
          Reintentar
        </button>
      </div>

      <!-- QR hint for 404 -->
      <p v-if="statusCode === 404" class="text-body-small text-on-surface-variant mt-6">
        Si escaneaste un código QR, verifica que sea el correcto o pide ayuda al personal del restaurante.
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
const error = useError()

const statusCode = computed(() => error.value?.statusCode || 500)

const title = computed(() => {
  switch (statusCode.value) {
    case 404: return 'Página no encontrada'
    case 403: return 'Acceso denegado'
    case 401: return 'Sesión expirada'
    default: return 'Algo salió mal'
  }
})

const description = computed(() => {
  switch (statusCode.value) {
    case 404: return 'La página que buscas no existe o ha sido movida.'
    case 403: return 'No tienes permiso para acceder a esta página.'
    case 401: return 'Tu sesión ha expirado. Inicia sesión de nuevo.'
    default: return 'Ha ocurrido un error inesperado. Por favor, inténtalo de nuevo.'
  }
})

const icon = computed(() => {
  switch (statusCode.value) {
    case 404: return 'search_off'
    case 403: return 'lock'
    case 401: return 'key_off'
    default: return 'error_outline'
  }
})

const iconStyle = computed(() => {
  switch (statusCode.value) {
    case 404: return 'background: linear-gradient(135deg, #F2CD5E 0%, #D4A828 100%)'
    case 403: return 'background: linear-gradient(135deg, #EF4444 0%, #DC2626 100%)'
    case 401: return 'background: linear-gradient(135deg, #F59E0B 0%, #D97706 100%)'
    default: return 'background: linear-gradient(135deg, #EF4444 0%, #DC2626 100%)'
  }
})

function handleClearError() {
  clearError({ redirect: '/' })
}

function retry() {
  clearError({ redirect: window.location.pathname })
}

useHead({
  title: `${statusCode.value} — ComandaPlus`,
})
</script>
